import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ExternalGlyph = /*#__PURE__*/createElement("svg", {
  id: "external",
  viewBox: "-3 -3 30 30"
}, /*#__PURE__*/createElement("g", {
  id: "external",
  stroke: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M19.5 19.9583H4.5C3.8125 19.9583 3.25 19.4146 3.25 18.75V4.25C3.25 3.58542 3.8125 3.04167 4.5 3.04167H10.75C11.4375 3.04167 12 2.49792 12 1.83333C12 1.16875 11.4375 0.625 10.75 0.625H3.25C1.8625 0.625 0.75 1.7125 0.75 3.04167V19.9583C0.75 21.2875 1.875 22.375 3.25 22.375H20.75C22.125 22.375 23.25 21.2875 23.25 19.9583V12.7083C23.25 12.0438 22.6875 11.5 22 11.5C21.3125 11.5 20.75 12.0438 20.75 12.7083V18.75C20.75 19.4146 20.1875 19.9583 19.5 19.9583ZM14.5 1.83333C14.5 2.49792 15.0625 3.04167 15.75 3.04167H18.9875L7.575 14.0738C7.0875 14.545 7.0875 15.3063 7.575 15.7775C8.0625 16.2488 8.85 16.2488 9.3375 15.7775L20.75 4.74542V7.875C20.75 8.53958 21.3125 9.08333 22 9.08333C22.6875 9.08333 23.25 8.53958 23.25 7.875V0.625H15.75C15.0625 0.625 14.5 1.16875 14.5 1.83333Z"
})));
const External = createSvg({
  name: 'external',
  path: ExternalGlyph,
  viewBox: '-3 -3 30 30'
});

export default External;
export { ExternalGlyph };
